import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpUtilsService } from 'app/core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from 'app/core/_base/crud';

const API_ROOT_URL = environment.ApiRoot + '/hc_baocom';

@Injectable()
export class HC_BaoComService {
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import: BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;
	constructor(private http: HttpClient,
		private httpUtils: HttpUtilsService) { }
	//#region thực đơn
	HcThucDon_Insert(data: any) {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(environment.ApiRoot + '/monan_thucdon/HcThucDon_Insert', data, { headers: httpHeaders });
	}
	getThucDon_Detail(tungay: any, denngay: any): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/monan_thucdon/ThucDon_Detail?TuNgay=${tungay}&DenNgay=${denngay}`, { headers: httpHeaders });
	}
	//#endregion

	//#region món ăn
	DmMonAnLite_List(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/monan_thucdon/DmMonAnLite_List`, { headers: httpHeaders });
	}
	//#endregion

	//#region đăng ký món ăn
	HcDangKyMonAn_List(tungay: any, denngay: any, idnv) {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/HcDangKyMonAn_List?IdNv=${idnv}&TuNgay=${tungay}&DenNgay=${denngay}`, { headers: httpHeaders });
	}
	HcDangKyMonAn_Insert(data: any[]) {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/HcDangKyMonAn_Insert', data, { headers: httpHeaders });
	}
	//#endregion

	//#region báo cơm
	createHC_BaoCom(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/HcBaoCom_Insert', item, { headers: httpHeaders });
	}
	//#endregion

	//#region báo cơm phát sinh
	updateSoLuongPhatSinh(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/HcBaoComPhatSinh_Insert', item, { headers: httpHeaders });
	}
	//#endregion

	//#region phiếu báo cơm
	HcPhieuBaoCom_Insert(item): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.post<any>(API_ROOT_URL + '/HcPhieuBaoCom_Insert', item, { headers: httpHeaders });
	}
	PhieuBaoCom_Detail(ngay): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/PhieuBaoCom_Detail?Ngay=${ngay}`, { headers: httpHeaders });
	}
	//#endregion

	//#region khác
	getWeeks(num): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/monan_thucdon/getWeeks?num=${num}`, { headers: httpHeaders });
	}
	getNhanVienByMa(manv): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/danhmuc/NhanVien_ByMa?manv=${manv}`, { headers: httpHeaders });
	}
	getBoPhan(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(environment.ApiRoot + `/danhmuc/DM_PhongBan_Tree`, { headers: httpHeaders });
	}
	getConfigTime(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL + `/getConfigTime`, { headers: httpHeaders });
	}
	//#endregion
}
